import { createSelector } from "reselect";

const getFusionGDBData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state.variantResult?.genes?.[state.selectedGeneIndexClinical]?.fusiongdb
    : state?.variantResult?.fusiongdb;
};

const getFusionGDBGenesNumber = createSelector(getFusionGDBData, (data) => {
  if (data) {
    return data?.fusion_genes?.length;
  }
  return null;
});

export { getFusionGDBData, getFusionGDBGenesNumber };
